import { render, staticRenderFns } from "./ManterLotacoesView.vue?vue&type=template&id=6d357da7"
import script from "./ManterLotacoesView.vue?vue&type=script&lang=js"
export * from "./ManterLotacoesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports